
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { withTranslation } from 'react-i18next';
import { makeAjax, respStatus, showMessage, url } from "../../helpers/global_helper"
const CloseTimeAndResult = (props) => {
    const gameId = useSelector((state) => state.CommonConfig.gameId);
    const device = useSelector(state => state.CommonConfig.device_type);
    const discountPrize = useSelector((state) => state.CommonConfig.discount);
    const [marketOpenclose, setMarketOpenclose] = useState({
        closeTime: null,
        timeWIB: null,
    });
    useEffect(() => {
        const reqData = { gameId };

        makeAjax(url.TOGEL_API.marketOpenClosedTime, reqData, url.TOGEL_MS_EXT)
            .then((response) => {
                if (response.status !== respStatus["SUCCESS"]) {
                    showMessage(response.message);
                    return;
                }
                let closeTime = '00.00';
                let timeWIB = '00.00';

                const result = response.data.schedule.find(item => item.type === 1);
                const OpenResult = response.data.schedule.find(item => item.type === 0);

                if (OpenResult) {
                    closeTime = formatTime(OpenResult.time);
                }

                function formatTime(timeString) {
                    const date = new Date(`1970-01-01T${timeString}`);
                    let hours = date.getHours();
                    let minutes = date.getMinutes();
                    hours = hours < 10 ? '0' + hours : hours;
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    return `${hours}:${minutes}`;
                }

                if (result) {
                    timeWIB = formatTime(result.time);
                }

                setMarketOpenclose({
                    closeTime,
                    timeWIB
                });
            });
    }, [gameId]);
    return (
        <>
            <div className="closetimeandresult">
                {device === "Mobile" &&
                    <p>Periode : {discountPrize.game_code} - {discountPrize.nextPeriode}</p>
                }
                <p>
                    {props.t('Close')} <span className="bluetxt">{marketOpenclose.closeTime}</span> WIB,
                </p>
                <p>
                    {props.t('result')} <span className="bluetxt">{marketOpenclose.timeWIB} </span>WIB
                </p>
            </div>
        </>
    )
}
export default withTranslation()(CloseTimeAndResult);